import { render, staticRenderFns } from "./PopUpAlert.vue?vue&type=template&id=1b4156e1&scoped=true"
import script from "./PopUpAlert.vue?vue&type=script&lang=js"
export * from "./PopUpAlert.vue?vue&type=script&lang=js"
import style0 from "./PopUpAlert.vue?vue&type=style&index=0&id=1b4156e1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4156e1",
  null
  
)

export default component.exports